ScoreTrekBattle.Event = (function() {
    var _this, EVENTS;

    EVENTS = {};

    _this = {
		on: function(eventTypes, eventCallback) {
            var ret;
            ret = [];
            String(eventTypes).split(' ').forEach(function(eventType) {
                if (eventType && eventType != '') {
                    if (!EVENTS.hasOwnProperty(eventType)) {
                        EVENTS[eventType] = [];
                    }
                    if (eventCallback) {
                        EVENTS[eventType].push(eventCallback);
                    }
                    ret = ret.concat(EVENTS[eventType]);
                }
            });
            return ret;
		},
        clear: function(eventType) {
            delete EVENTS[eventType];
        },
		trigger: function(eventType, functionArguments) {
			var i, ret;
			ret = true;
			if (!EVENTS.hasOwnProperty(eventType)) {
                console.info(`Unhandled event: ${eventType}`);
                EVENTS[eventType] = [];
            }
            for (i = 0; i < EVENTS[eventType].length; i++) {
                try {
                    ret = ret && (_this.applyFunction.call(this, EVENTS[eventType][i], functionArguments) !== false);
                } catch (e) {
                    console.error(e);
                }
            }
			return ret;
		},
		callFunction: function(functionReference) {
            var params;
			if (functionReference) {
                params = Array.prototype.slice.call(arguments);
                params.shift(); //remove func
				try {
					return functionReference.apply(this || {}, params);
				} catch (e) {
					console.error(e);
				}
			}
		},
		applyFunction: function(functionReference, params) {
			if (functionReference) {
				if (!Array.isArray(params)) {
					params = [params];
				}
				try {
					return functionReference.apply(this || {}, params);
				} catch (e) {
					console.error(e);
				}
			}
		},
        debug: function() {
            console.log(EVENTS);
        }
    };

    $(document).on('click', '[data-trigger-action]', function(event) {
        var action, actionParams, stopEvent;

        // if (this.closest('.isDragging') !== null) {
        //     return;
        // }

        actionParams = String(this.dataset.triggerAction).split(':');
        action = actionParams.shift();
        actionParams.unshift(event);

        stopEvent = (_this.trigger.call(this, `action.${action}`, actionParams) === false);

        if (!stopEvent) {
            stopEvent = ($(this).parent().closest('[data-trigger-action]').length > 0);
        }

        if (stopEvent) {
            event.preventDefault();
            event.stopPropagation();
        };
    });

    $(document).on('click', 'html', function(event) {
        _this.trigger.call(this, `root.click`, [event]);
    });

    return _this;
})();